import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import styles from './CartSkeleton.module.scss';

function CartSkeleton({ nbrOfRows = 3 }) {
  function getRows() {
    const arr = new Array(nbrOfRows);
    for (let i = 0; i < nbrOfRows; i++) {
      arr.push(
        <tr key={`skeleton-row-${i}`}>
          <td>
            <div className={styles.Line} />
          </td>
          <td>
            <div className={`${styles.Line} justify-content-end`} />
          </td>
          <td>
            <div className={`${styles.Line} justify-content-end`} />
          </td>
        </tr>
      );
    }
    return arr;
  }
  return (
    <Table borderless className={styles.TableLined}>
      <tbody className={styles.List}>{getRows()}</tbody>
    </Table>
  );
}

CartSkeleton.propTypes = {
  nbrOfRows: PropTypes.number
};

CartSkeleton.defaultProps = {
  nbrOfRows: 3
};

export default CartSkeleton;
